import { newReleaseList } from "@/mocks/manhwa";

export default function NewReleases() {
  return (
    <section id="newrelease" className="bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-sm font-medium text-primary-700">
              <i className="ri-flashlight-line"></i> 新上架
            </span>
            <h2 className="mt-4 font-heading text-2xl font-black text-foreground-900 md:text-4xl">好看的人气新作</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              最近口碑爆棚、讨论度一路走高的新连载，抢先一步追更，成为第一批见证神作诞生的读者。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50 px-4 py-2 text-sm font-medium text-foreground-600 ring-1 ring-background-200">
            <i className="ri-time-line text-primary-500"></i> 每周五更新榜单
          </span>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {newReleaseList.map((item) => (
            <article
              key={item.title}
              className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:shadow-md"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.cover}
                  alt={`${item.title} 人气新作韩国漫画`}
                  className="aspect-[7/10] w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">
                  <i className="ri-fire-fill"></i> 热门
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-900">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">{item.author} · {item.genre}</p>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-700">{item.desc}</p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-800">
                    {item.tags[0]}
                  </span>
                  <span className="font-heading text-base font-black text-primary-600">{item.score.toFixed(1)} 分</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}